import { useEffect } from "react";

import { createFileRoute, useSearch } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useAuth } from "@workos-inc/authkit-react";
import { z } from "zod";

import FullScreenLoader from "@/layouts/FullScreenLoader";

const searchSchema = z.object({
  redirect: z.string().default("/"),
  context: z.string().optional(),
  invitationToken: z.string().optional(),
  invitation_token: z.string().optional(),
  organizationId: z.string().optional(),
  organization_id: z.string().optional(),
  loginHint: z.string().optional(),
  login_hint: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: zodValidator(searchSchema),
  component: LoginRoute,
});

function LoginRoute() {
  const { signIn, user, organizationId, isLoading } = useAuth();
  const {
    redirect,
    context,
    invitationToken,
    invitation_token,
    organizationId: queryOrganizationId,
    organization_id,
    loginHint,
    login_hint,
  } = useSearch({ from: "/login" });

  useEffect(() => {
    if (isLoading) return;

    const normalizedInvitationToken = invitationToken ?? invitation_token;
    const normalizedOrganizationId = queryOrganizationId ?? organization_id;
    const normalizedLoginHint = loginHint ?? login_hint;

    if (user && organizationId) {
      const returnTo = redirect === window.location.pathname ? "/" : redirect;
      window.location.replace(returnTo);
      return;
    }

    void signIn({
      ...(context ? { context } : {}),
      ...(normalizedInvitationToken ? { invitationToken: normalizedInvitationToken } : {}),
      ...(normalizedOrganizationId ? { organizationId: normalizedOrganizationId } : {}),
      ...(normalizedLoginHint ? { loginHint: normalizedLoginHint } : {}),
      state: { returnTo: redirect },
    });
  }, [
    context,
    invitationToken,
    invitation_token,
    isLoading,
    loginHint,
    login_hint,
    organizationId,
    organization_id,
    queryOrganizationId,
    redirect,
    signIn,
    user,
  ]);

  return <FullScreenLoader />;
}
